// import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { QuestionPage } from '../models/question_page';
import { Question } from '../models/question';
import { Answer } from '../models/answer';

@Injectable({
  providedIn: 'root'
})
export class CheckRutService {
  validation_executed: boolean = false;
  constructor(
    private http: HttpClient,
  ) { }

  private getHeaders() {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-api-key': environment.check_rut_api_key
      })
    };
    return httpOptions;
  }
  
      

  async checkRut(api_url: string, rut: string, survey_uuid: string) {
    this.validation_executed = false;
    const response = await lastValueFrom(
      this.http.post(
        api_url,
        {
          rut: rut,
          survey_uuid: survey_uuid
        },
        this.getHeaders()
      ).pipe(map(response => {
        return {
          valid: true,
          answered: response['data']['complete_survey'],
          error: false
        }
      }))
    ).catch((error) => {
      // console.error("error from api",error);
      if(error.status == 404){
        return {
          valid: false,
          answered: false,
          error: false
        }
      }else if(error.status == 409){
        return {
          valid: true,
          answered: true,
          error: false
        }
      }else{
        return {
          error: true
        }
      }
    });
    this.validation_executed = true;
    return response;
  }

  async markRutAsCompleted(api_url: string , rut: string, survey_uuid: string, respondent_uuid: string) {
    const response = await lastValueFrom(
      this.http.post(
        api_url,
        {
          rut: rut,
          survey_uuid: survey_uuid,
          respondent_uuid: respondent_uuid
        },
        this.getHeaders()
      ).pipe(map(response => {
        return {
          valid: true,
          answered: response['data']['complete_survey'],
        }
      }))
    ).catch((error) => {
      console.error("error from api",error);
    });

    return response;
  }

  /**
   * Check if survey has questions with validation_type == "RUT" and return the rut answer
   * if it has, otherwise return null
   * @param surveyPages
   * @param answers
   * @returns string|null
   * */
  checkIfHasRutQuestions( surveyPages: QuestionPage[], answers: Answer[]): {remote_validation_confirm_url: string, answer: string}[]| null {
    // then return the first question with validation_type == "RUT"
    let remoteValidationtRutQuestions: Question[] = [];
    for (const page of surveyPages) {
      const question = page.questions.find(q => q.validation_type === "RUT" && q.remote_validation);      
      if (question)
        remoteValidationtRutQuestions.push(question);
    }

    if (remoteValidationtRutQuestions.length > 0) {
      let response = remoteValidationtRutQuestions.map(question => {
        return {
          remote_validation_confirm_url: question.remote_validation_confirm_url,
          answer: answers.find(answer => answer.question_id == question.id)?.answer
        }
      });
      return response;
    }
    else
      return null;
  }
}
